// extracted by mini-css-extract-plugin
export var arrows = "_24-5";
export var decrementer = "_24-9";
export var disabled = "_24-3";
export var error = "_24-1";
export var hiddenText = "_24-a";
export var incrementer = "_24-8";
export var input = "_24-7";
export var inputWrapper = "_24-0";
export var leadingIcon = "_24-b";
export var readonly = "_24-2";
export var regular = "_24-6";
export var small = "_24-4";